import * as React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, {registerLocale} from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import {forwardRef, useEffect, useState} from 'react';
import {formatDate, formatHourDatePicker} from '../Service';
import {Box} from '@mui/material';
import {Stack, Typography} from '@mui/material';
import {ReactComponent as Calendar} from '../../icon/Calendar.svg';
import {ReactComponent as Time} from '../../icon/Time.svg';
import {ReactComponent as Rectangle} from '../../icon/Rectangle.svg';
import {useDarkMode} from '../darkMode/hook/useDarkMode';

const DateFormat = ({
  label,
  startDate,
  setStartDate,
  includeDates,
  excludeTimes,
}) => {
  console.log('startDate', startDate);
  useEffect(() => {
    if (!startDate) {
      setStartDate(new Date());
    }
  }, []);
  registerLocale('fr', fr);
  const setDate = date => {
    console.log('date', date);
    setStartDate(date);
  };
  const {mode} = useDarkMode();
  const CustomInput = forwardRef(({value, onClick}, ref) => (
    <Box
      className="datePickerHeader"
      onClick={onClick}
      ref={ref}
      sx={{cursor: 'pointer'}}
      style={{backgroundColor: mode.settings.inputBackgroundColor}}>
      <Stack
        direction="row"
        justifyContent={'space-around'}
        alignItems={'center'}
        sx={{color: '#26383E'}}>
        <Calendar></Calendar>
        <Stack sx={{width: '160px'}}>
          <Typography
            variant={'subtitle4'}
            style={{color: mode.settings.textColor3}}>
            {label}
          </Typography>
          <Typography
            variant={'subtitle3'}
            style={{color: mode.settings.textColor3}}>
            {value ? formatDate(value) : ''}
          </Typography>
        </Stack>
        <Rectangle></Rectangle>
        <Time></Time>
        <Stack>
          <Typography
            variant={'subtitle4'}
            style={{color: mode.settings.textColor3}}>
            Heure
          </Typography>
          <Typography
            variant={'subtitle3'}
            style={{color: mode.settings.textColor3}}>
            {value ? formatHourDatePicker(value) : ''}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  ));

  return (
    <Box>
      <DatePicker
        selected={startDate}
        onChange={date => setDate(date)}
        locale="fr"
        showPopperArrow={false}
        showTimeSelect
        timeIntervals={15}
        timeCaption="Heure"
        customInput={<CustomInput />}
        includeDates={includeDates ? includeDates : null}
        excludeTimes={excludeTimes ? excludeTimes : []}
        minDate={new Date()}
        dateFormat="MM dd, yyyy HH:mm:ss"
      />
    </Box>
  );
};

export default DateFormat;
